import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRentalType.ts
var t = () => e("rentalType");
//#endregion
export { t as useTrRentalType };
